export interface RevokeTrustBtnData {
  projectId: string;
  isProjectLevelExtension: boolean;
  extensionLabel: string;
}

export function isInstanceOfRevokeTrustBtnData(
  object: unknown,
): object is RevokeTrustBtnData {
  const o = object as RevokeTrustBtnData;
  return (
    !!object &&
    typeof object === 'object' &&
    typeof o.projectId === 'string' &&
    typeof o.isProjectLevelExtension === 'boolean' &&
    typeof o.extensionLabel === 'string'
  );
}
